module.exports = __webpack_public_path__ + "media/images/athletes/1644-c14235e0b2455794fa7a8862736b798e.png";